/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { QuestionLibraryItemRepositoryResponsePaginatedResponse } from "../types/QuestionLibraryItemRepositoryResponsePaginatedResponse.ts";
import { questionLibraryItemRepositoryResponseSchema } from "./questionLibraryItemRepositoryResponseSchema.ts";

export const questionLibraryItemRepositoryResponsePaginatedResponseSchema =
  z.object({
    data: z
      .array(z.lazy(() => questionLibraryItemRepositoryResponseSchema))
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  }) as unknown as ToZod<QuestionLibraryItemRepositoryResponsePaginatedResponse>;
